import React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import { Flexbox } from 'cw-ui-core';
import css from './Flyout.scss';

function Flyout({ Content = 'div', className }) {
    return (
        <Flexbox className={cx(css.container, className)} column>
            {typeof Content === 'function' ? <Content /> : Content}
        </Flexbox>
    );
}

Flyout.propTypes = {
    Content: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element]),
    className: PropTypes.string,
};

Flyout.defaultProps = {
    Content: 'div',
    className: '',
};

export default Flyout;
